<label
  [attr.for]="_id"
  class="go-form__label"
  [ngClass]="{ 'go-form__label--dark': theme == 'dark' }"
>
  {{ label }}
  <go-required-text [control]="control"></go-required-text>
</label>

<div class="go-datepicker">
  <input
    #datepickerInput
    class="go-form__input"
    [id]="_id"
    [placeholder]="placeholder"
    (keyup)="restrictInput()"
    [ngClass]="inputClasses"
    [(ngModel)]="selectedDate"
    (blur)="validateDate()"
    [disabled]="control.disabled"
    (input)="onInputCloseCalendar()"
    (click)="toggleDatepicker($event)"
  />
  <go-icon-button
    class="go-datepicker__toggle"
    [buttonDisabled]="control.disabled"
    buttonIcon="today"
    (click)="toggleDatepicker($event)"
  ></go-icon-button>
  <go-calendar
    *ngIf="goCalendar.isOpen"
    [appendToContent]="appendToContent"
    [appendTo]="appendTo"
    (datePicked)="datePicked($event)"
    [maxDate]="max"
    [minDate]="min"
    [locale]="locale"
    [displayFromRight]="displayFromRight"
    [displayAbove]="displayAbove"
    [calendar]="goCalendar"
  ></go-calendar>
</div>

<go-hint *ngFor="let hint of hints" [message]="hint" [theme]="theme"></go-hint>
<div *ngIf="!hideFieldError">
  <go-form-errors [control]="control" [theme]="theme"></go-form-errors>
</div>
